<cache-date></cache-date>

<filterForm [addFilterParams]="filter.addFilterParams"></filterForm>

<div class="row">
	<div class="col-md-12">
		<chart [data]="chartCompletedRegistrations.data" [options]="chartCompletedRegistrations.options" [sextant]="'chartCompletedRegistrations'" [url]="filter.currentUrl"></chart>
	</div>
</div>

<br>

<div class="row">
	<div class="col-md-12">
		<chart [data]="chart.data" [options]="chart.options" [sextant]="'chart'" [url]="filter.currentUrl"></chart>
	</div>
</div>

<hr><br>

<p>
	{{ 'adminstat.common.All count' | translate }}: {{ totalCount }} <br>
	{{ 'adminstat.common.In query count' | translate }}: {{ queryCount }}
</p>
<hr><br>

<button type="button" [class]="type == 'all' ? 'btn btn-danger' : 'btn btn-secondary'" (click)="changeType()">{{ 'adminstat.template.show ' + (type == 'all' ? 'notFound' : 'all') | translate }}</button>
<br><br>

<loading [isLoad]="statsLoader"></loading>
<table class="table" *ngIf="!statsLoader && stats.length > 0" [sextant]="'stats'" [url]="filter.currentUrl">
	<thead>
		<tr>
			<th>{{ 'adminstat.template.search phrase' | translate }}</th>
			<th>{{ 'adminstat.template.searchCount' | translate }}</th>
			<th>{{ 'adminstat.template.foundCount' | translate }}</th>
		</tr>
	</thead>

	<tbody>
		<tr *ngFor="let stat of stats">
			<td>
				<span class="badge badge-danger" *ngIf="stat.resultCount == 0" [ngStyle]="{'font-size': '15px;'}">{{ stat.searchQuery }}</span>
				<p *ngIf="stat.resultCount > 0">{{ stat.searchQuery }}</p>
			</td>
	
			<td>
				{{ stat.totalCount }}
			</td>
	
			<td>
				<button-anhor *ngIf="stat.resultCount > 0" (click)="showDetails(stat.searchQuery)" [sextant]="'details-' + key">
					{{ stat.resultCount }}
				</button-anhor>
				
				<ng-container *ngIf="stat.resultCount == 0">
					{{ stat.resultCount }}
				</ng-container>
			</td>
		</tr>
	</tbody>
</table>

<br><br>


